import "./MedicalEmergencyListScreen.css";

import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  InfiniteScroll,
  TextInput,
  Text,
  Accordion,
  AccordionPanel,
  Menu,
  Layer,
  Select,
  Tabs,
  Tab,
  DataTable,
  CheckBox,
  List,
} from "grommet";
import { Refresh } from "grommet-icons";

import MedicalEmergencyService from "../../../../../../services/medical-emergency/medical-emergency.service";
import {
  IMedicalEmergencyApiResponse,
  MedicalEmergencyStatus,
} from "../../../../../../services/medical-emergency/typings/IMedicalEmergencyApiResponse";
import MedicalEmergencyItem from "../common/MedicalEmergencyItem/MedicalEmergencyItem";
import { useNavigate } from "react-router-dom";
import StandardColors from "../../../../../../util/StandardColors";
import { useUser } from "../../../../context/User/UserContext";
import PassengerService from "../../../../../../services/passenger/passenger.service";
import { Map } from "immutable";
import { IEmsResponse } from "../../../../../../services/ems/typings/IEmsResponse";
import EmsService from "../../../../../../services/ems/ems.service";
import { escape } from "querystring";
import { useNewEmergency } from "../../../../context/MedicalListContext/MedicalListContext";
import { useErrorHandler } from "../../../common/context/ErrorStore";
import { useStore } from "../../../../../../Hooks/useStore";
import { observer } from "mobx-react";
import { runInAction, toJS, values } from "mobx";
import { Mixpanel } from "../../../../../../util/Helper";
import CommonButton from "../../../common/Button/CommonButton";
import CommonSearchInput from "../../../common/SearchInput/CommonSearchInput";
import Chip from "../../../common/chip/Chip";
import StatusChip from "../../../common/status-chip/StatusChip";
import closeSidebar from "../../../../../../assets/close_small.svg";
import noResult from "../../../../../../assets/no-result.png";
import { toNumber } from "lodash";
import AssignModal from "./Modal/AssignModal";
import AssignToSomeoneModal from "./Modal/AssignSomeone";
import {
  subscribeToTopic,
  unsubscribeToTopic,
  sendDataToTopic,
} from "../../../../../../App";
import { Autoupdateenum } from "../../../../../../enums";
import Pagination from "../../../common/Pagination/Pagination";
import Utility from "../../../../../../util/api/Utility";
import PhysicianColumn from "../../../../../PhysicianColumn/PhysicianColumn";

type MedicalEmergenciesScreenType = {
  filterDate?: string;
  showSearch?: boolean;
  showId?: boolean;
  hideSymptoms?: boolean;
};

const MedicalEmergencyListScreen = observer(
  ({
    filterDate,
    showSearch,
    showId,
    hideSymptoms,
  }: MedicalEmergenciesScreenType) => {
    const navigation = useNavigate();
    const { user } = useUser();

    const { rootStore } = useStore();
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);

    const [searchValue, setSearchValue] = useState("");
    const [medicalEmergencies, setMedicalEmergencies] = useState(
      [] as IMedicalEmergencyApiResponse[]
    );
    const [passengerIdNameMap, setPassengerIdNameMap] = useState(Map({}));
    const [activePanelIndexes, setActivePanelIndexes] = useState([0]);
    const [selectedMedicalEmergencyIdList, setSelectedMedicalEmergencyIdList] =
      useState({} as { [id: number]: boolean });
    const [showAssignModal, setShowAssignModal] = useState(false);
    const [emsList, setEmsList] = useState([] as IEmsResponse[]);
    const [emsSearchString, setEmsSearchString] = useState("");
    const [selectedEmsId, setSelectedEmsId] = useState("");

    const onMedicalEmergencyChecked = (
      id: number,
      isChecked: boolean,
      ems: string
    ) => {
      // setSelectedMedicalEmergencyIdList((prev) => {
      //   return {
      //     ...prev,
      //     [id]: isChecked,
      //   };
      // });
      let isAdmin = rootStore.emsStore.getRoleLabel.toLowerCase() == "admin";
      if (!isAdmin) {
        let checkLabel = isChecked == true ? "check" : "uncheck";
        let isAssign = user?.username == ems;
        Mixpanel.track("web_medical_emergency_" + checkLabel, {
          name: user?.username,
        });
        rootStore.emsStore.handleSelectedMedicalIdList(id, isChecked);
        rootStore.emsStore.handleSelectedMedicalIdListEms(
          id,
          isChecked ? isAssign : false
        );
      }
    };

    const { newEmergencyNotification, handleNewEmergencyNotification } =
      useNewEmergency();
    const [activeTab, setActiveTab] = useState(0);
    const [status, setStatus] = useState("");
    const [filteredMedicalEmergencies, setFilteredMedicalEmergencies] =
      useState([] as IMedicalEmergencyApiResponse[]);
    const [filterList, setFilterList] = useState(
      [] as IMedicalEmergencyApiResponse[]
    );

    const loadMedicalEmergenciesByEmsId = useCallback(
      async (emsId: string | undefined) => {
        if (emsId === undefined) {
          return;
        }
        rootStore.loadingStore.setShowLoader(true);
        const medicalEmergencies_ =
          await MedicalEmergencyService.listMedicalEmergenciesByEms(emsId);
        rootStore.emsStore.medicalEmergencies = medicalEmergencies_;
        // await rootStore.emsStore.getMedicalEmergecies();
        // setMedicalEmergencies(medicalEmergencies_);
        rootStore.loadingStore.setShowLoader(false);
      },
      [rootStore.emsStore.getNewEmergency]
    );

    useEffect(() => {
      return () => {
        rootStore.emsStore.resetReportIndicator();
      };
    }, []);

    let userInfo;
    useEffect(() => {
      (async () => {
        userInfo = localStorage.getItem("userinfo");
        if (userInfo) {
          let roleLabel = JSON.parse(userInfo).roleLabel;
          rootStore.emsStore.handleRoleLabel(roleLabel);
        }
      })();
    }, [userInfo]);

    const loadMedicalEmergencies = useCallback(async () => {
      rootStore.loadingStore.setShowLoader(true);
      // unsubscribeToTopic();
      try {
        let isAdmin = rootStore.emsStore.getRoleLabel.toLowerCase() == "admin";
        const medicalEmergencies_ =
          await MedicalEmergencyService.listMedicalEmergencies(isAdmin);
        // await rootStore.emsStore.getMedicalEmergecies();
        rootStore.emsStore.handleMedicalEmergecies(medicalEmergencies_);
        console.log("medicalEmergencies_", medicalEmergencies_);

        medicalEmergencies_.forEach((emergency, index) => {
          const flightId = emergency.flightPrimaryKey;
          console.log("testssss" + flightId); //
          console.log(JSON.stringify(rootStore.emsStore.getFlightsubscribe));
          // Check if flightId has already been logged
          if (!rootStore.emsStore.getFlightsubscribe[flightId]) {
            console.log("test" + flightId); // Log the flightId

            // Mark this flightId as logged
            rootStore.emsStore.handleFlightsubscribe(flightId);
            subscribeToTopic(flightId, rootStore);
          }
        });
        // runInAction(() => {
        //   rootStore.emsStore.medicalEmergencies = medicalEmergencies_;
        // })
        // setMedicalEmergencies(medicalEmergencies_);
      } catch (error) {
        console.log("listMedicalEmergencies", error);
      } finally {
        rootStore.loadingStore.setShowLoader(false);
      }
    }, [rootStore.emsStore.getNewEmergency]);

    const month = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const getMonthName = (monthNum: number) => {
      let monthIndex = monthNum - 1;
      return month[monthIndex];
    };

    const getTimeWithInfo = (hourCount: number) => {
      if (hourCount > 12) {
        return "am";
      } else {
        return "pm";
      }
    };

    const getPrettyTime = (date: Date) => {
      let formattedTime = Utility.getFormatedTime(date);
      console.log("formattedTime", formattedTime);
      return formattedTime;
    };

    const getFormatedDate = (date: Date) => {
      let localDateTime = Utility.convertUTCToLocal(date);
      let formattedDate = Utility.getFormatedDate(localDateTime);
      return formattedDate;
    };

    const showPrettySymptom = (symp: string) => {
      console.log("symptom", symp);
      let arr = symp.split(",");
      console.log("symptoms array", arr);
      return arr.map((symptom: string, index: number) => {
        if (index > 3) {
          if (index > 4) return;
          return (
            <Chip
              key={symptom}
              containerStyle={{
                backgroundColor: "#f2f7ff",
                color: "$41454b",
              }}
              title={"+" + (arr.length - 4).toString()}
            />
          );
        } else {
          return (
            <Chip
              key={symptom}
              containerStyle={{ backgroundColor: "#f2f7ff", color: "$41454b" }}
              title={symptom}
            />
          );
        }
      });
    };

    const column2 = [
      {
        property: "name",
        header: <Text></Text>,
        primary: true,
        render: (item: any) => {
          return (
            <CheckBox
              onChange={(event) => {
                onMedicalEmergencyChecked(
                  item.id,
                  event.target.checked,
                  item.assignedEms
                );
              }}
              onClick={(event) => {
                event.stopPropagation();
              }}
              pad="none"
              className="checkbox"
              checked={
                rootStore.emsStore.getSelectedMedicalList[item.id] == true &&
                true
              }
              style={{ height: 10, width: 10 }}
            />
          );
        },
      },
      {
        property: "Passenger Name",
        header: <Text style={{ textAlign: "center" }}>Passenger Name</Text>,
        primary: true,
        render: (item: any) => {
          return (
            <div style={{ alignItems: "center", textAlign: "center" }}>
              <div>{item.passengerName}</div>
            </div>
          );
        },
      },
      {
        property: "flight no",
        header: <Text style={{ textAlign: "center" }}>Flight No.</Text>,
        primary: true,
        render: (item: any) => {
          return <div style={{ alignItems: "center", textAlign: "center" }}>{item.flightId}</div>;
        },
      },
      {
        property: "Date",
        header: <Text style={{ textAlign: "center" }}>Date</Text>,
        primary: true,
        render: (item: any) => {
          return <div style={{ alignItems: "center", textAlign: "center" }}>{getFormatedDate(item.timestamp)}</div>;
        },
      },
      {
        property: "Time",
        header: <Text style={{ textAlign: "center" }}>Time</Text>,
        primary: true,
        render: (item: any) => {
          return <div style={{ alignItems: "center", textAlign: "center" }}>{getPrettyTime(item.timestamp)}</div>;
        },
      },
      {
        property: "Physician Assigned",
        header: <Text style={{ textAlign: "center" }}>Physician Assigned</Text>,
        primary: true,
        render: (item: any) => {
          return <div style={{ alignItems: "center", textAlign: "center" }}><PhysicianColumn item={item} /></div>;
        },
      },
      {
        property: "Status",
        header: <Text style={{ textAlign: "center" }}>Status</Text>,
        primary: true,
        render: (item: any) => {
          return (
            <div
              style={{ width: 105, wordWrap: "normal", alignSelf: "center" }}
            >
              <StatusChip status={item.status} />
            </div>
          );
        },
      },
      {
        property: "Observations",
        header: <Text style={{ textAlign: "center" }}>Observations</Text>,
        primary: true,
        render: (item: any) => {
          return (
            <div className="symptom" style={{ textAlign:"center"}}>
              {item.symptoms.trim() == "" ? (
                <Text className="no-observation">
                  Complaints & Observations not specified
                </Text>
              ) : (
                showPrettySymptom(item.symptoms)
              )}
            </div>
          );
        },
      },
    ];

    useEffect(() => {
      let endpointRegisterError = localStorage.getItem("registerEndPointError");
      if (endpointRegisterError != null) {
        let error = endpointRegisterError;
        let errorSplitArray = error.split(": ");
        let formattedError = errorSplitArray[1];
        // rootStore.errorHandlingStore.displayError(formattedError);
        localStorage.removeItem("registerEndPointError");
      } else {
        let endpointRegister = localStorage.getItem("isRegister");
        console.log("isendpointRegister", endpointRegister);
        if (endpointRegister != "1") {
          localStorage.setItem("isRegister", "1");
          window.location.reload();
        }
      }
    }, []);

    useEffect(() => {
      loadMedicalEmergencies();
      console.log(
        "newEmergencyNotification",
        rootStore.emsStore.getNewEmergency
      );
    }, [rootStore.emsStore.getNewEmergency]);

    const loadPassengers = useCallback(
      async (medicalEmergencies: IMedicalEmergencyApiResponse[]) => {
        medicalEmergencies.forEach(async (medicalEmergency) => {
          const response = await PassengerService.getPassenger(
            medicalEmergency.passengerId
          );
          rootStore.emsStore.handlePassengerIdNameMapState(
            medicalEmergency.passengerId.toString(),
            response?.name
          );
          // setPassengerIdNameMap((prev) =>
          //   prev.set(medicalEmergency.passengerId.toString(), response?.name)
          // );
        });
      },
      [rootStore.emsStore.getPassengerIdNameMapState]
    );

    const onMedicalEmergencyClicked = (
      medicalEmergency: IMedicalEmergencyApiResponse
    ) => {
      Mixpanel.track("web_medical_click", { name: user?.username });
      rootStore.emsStore.handleSelectedEmergency(medicalEmergency);
      let isAdmin = rootStore.emsStore.getRoleLabel.toLowerCase() == "admin";
      if (!isAdmin) {
        const navigationPath = "emergency/" + medicalEmergency.id;

        // navigation(navigationPath as never, {
        //   replace: true,
        // });
        navigation(navigationPath);
      }
    };
    const assignToMeClicked = async () => {
      // assign to me call
      Mixpanel.track("web_assign_to_me_click", { name: user?.username });
      rootStore.loadingStore.setShowLoader(true);
      try {
        if (user?.username) {
          const selectedMedicalList = rootStore.emsStore.getSelectedMedicalList;
          let allTrueMe = {} as { [id: number]: boolean };
          for (const id in selectedMedicalList) {
            if (
              selectedMedicalList.hasOwnProperty(id) &&
              selectedMedicalList[id]
            ) {
              allTrueMe[id] = selectedMedicalList[id];
            }
          }

          await MedicalEmergencyService.setMedicalEmergencyEms(
            Object.keys(allTrueMe).map(Number),
            user.username
          );
          rootStore.emsStore.handleAssignToMeModal(true);
        }
      } catch (e) {}
      rootStore.loadingStore.setShowLoader(false);
    };

    const assignToSomeoneClicked = async () => {
      Mixpanel.track("web_assign_to_someone_click", { name: user?.username });
      try {
        let emsList = await EmsService.listEmsProviders();
        rootStore.emsStore.EmsList = emsList;
        console.log(rootStore.emsStore.getEmsList);
        rootStore.emsStore.handleAssignModal(true);
      } catch (e) {}
    };

    const onAssignEmergencyClicked = async () => {
      Mixpanel.track("web_assign_emergency_click", { name: user?.username });
      if (rootStore.emsStore.selectedEmsId === "") {
        alert("Please select a provider");
        return;
      }
      rootStore.emsStore.handleEmsListSearch("");
      rootStore.loadingStore.setShowLoader(true);
      try {
        const selectedMedicalList = rootStore.emsStore.getSelectedMedicalList;

        let allTrueMe = {} as { [id: number]: boolean };
        for (const id in selectedMedicalList) {
          if (
            selectedMedicalList.hasOwnProperty(id) &&
            selectedMedicalList[id]
          ) {
            allTrueMe[id] = selectedMedicalList[id];
          }
        }

        await MedicalEmergencyService.setMedicalEmergencyEms(
          Object.keys(allTrueMe).map(Number),
          rootStore.emsStore.selectedEmsId
        );
        rootStore.emsStore.handleAssignToSomeoneModal(true);
        // for (const id in allTrueMe) {
        //   if (allTrueMe.hasOwnProperty(id)) {
        // rootStore.emsStore.resetSelectedMedicalIdList();
        //   }
        // };
      } catch (e) {}
      rootStore.loadingStore.setShowLoader(false);
      // loadMedicalEmergencies();
      rootStore.emsStore.handleAssignModal(false);
      rootStore.emsStore.handleEmsSearchString("");
      rootStore.emsStore.resetSelectedMedicalIdListEms();
      rootStore.emsStore.resetSelectedMedicalIdList();
      // rootStore.emsStore.handleSelectEmsId("");
      // rootStore.emsStore.handleAssignToSomeoneModal(false);
    };

    useEffect(() => {
      if (user) {
        if (user["custom:type"] === "ems") {
          loadMedicalEmergencies();
        } else {
        }
      }
    }, [user]);

    // useEffect(() => {
    //   console.log("emergencyList", rootStore.emsStore.getEmergencies);
    //   loadPassengers(rootStore.emsStore.getEmergencies);
    // }, [loadPassengers, rootStore.emsStore.getEmergencies]);

    useEffect(() => {
      rootStore.emsStore.handleSelectedEmergency(null);
      rootStore.emsStore.passenger = null;
      rootStore.emsStore.handleVideoCallRecord(null);
      rootStore.emsStore.resetReportIndicator();
    }, []);
    const totalItems = filterList.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    useEffect(() => {
      const filterME = rootStore.emsStore.getEmergencies.filter((item) => {
        let dateFound = true;

        if (filterDate !== undefined) {
          const selectedDateMs = new Date(Date.parse(filterDate));
          const medicalEmergencyDateMs = new Date(Date.parse(item.timestamp));
          selectedDateMs.setHours(0, 0, 0, 0);
          medicalEmergencyDateMs.setHours(0, 0, 0, 0);
          dateFound =
            selectedDateMs.getTime() === medicalEmergencyDateMs.getTime();
        }

        const search = rootStore.emsStore.getSearchString?.toLowerCase?.() || "";

        return (
          (
            item.flightId?.toLowerCase?.().includes(search) ||
            item.status?.toLowerCase?.().includes(search) ||
            item.symptoms?.toLowerCase?.().includes(search) ||
            item.passengerName?.toLowerCase?.().includes(search)
          ) && dateFound
        );
      });
      console.log("filterME1", toJS(rootStore.emsStore.getEmergencies));
      console.log("filterME2", filterME);
      setFilteredMedicalEmergencies(filterME);
      console.log("filterME3", filteredMedicalEmergencies);
    }, [rootStore.emsStore.getEmergencies, rootStore.emsStore.getSearchString]);

    // const filteredMedicalEmergencies = rootStore.emsStore.getEmergencies.filter((item) => {
    //   let dateFound = true;
    //   if (filterDate !== undefined) {
    //     const selectedDateMs = new Date(Date.parse(filterDate));
    //     const medicalEmergencyDateMs = new Date(Date.parse(item.timestamp));
    //     selectedDateMs.setHours(0, 0, 0, 0);
    //     medicalEmergencyDateMs.setHours(0, 0, 0, 0);
    //     dateFound = selectedDateMs.getTime() === medicalEmergencyDateMs.getTime();
    //   }

    //   return (
    //     (item.flightId.toLowerCase().includes(rootStore.emsStore.searchValue) ||
    //       item.status.toLowerCase().includes(rootStore.emsStore.searchValue) ||
    //       item.symptoms.toLowerCase().includes(rootStore.emsStore.searchValue) ||
    //       (rootStore.emsStore.getPassengerIdNameMapState.get(item.passengerId.toString()) as string)
    //         .toLowerCase()
    //         .includes(rootStore.emsStore.searchValue)) &&
    //     dateFound
    //   );
    // });

    const showActionButton = Object.values(
      rootStore.emsStore.getSelectedMedicalList
    ).some((value) => value === true);

    const showAssignButton = Object.values(
      rootStore.emsStore.getSelectedMedicalListEms
    ).some((value) => value === true);

    const filteredEmsList =
      rootStore.emsStore.getemsSearchString === ""
        ? rootStore.emsStore.EmsList
        : rootStore.emsStore.EmsList.filter((ems) =>
            (ems.name + " " + ems.familyName)
              .toLowerCase()
              .includes(rootStore.emsStore.getemsSearchString.toLowerCase())
          );

    // useEffect(() => {
    //   if(rootStore.emsStore.getActiveTab == 0) {
    //     setFilterList(filteredMedicalEmergencies.filter(
    //       (item) => item.assignedEms === user?.username && item.status !== MedicalEmergencyStatus.RESOLVED
    //     ));
    //   } else if (rootStore.emsStore.getActiveTab == 1) {
    //     setFilterList(filteredMedicalEmergencies.filter(
    //       (item) => {
    //         if (rootStore.emsStore.getStatusFilterValue == "") {
    //           item.status !== MedicalEmergencyStatus.RESOLVED;
    //         } else {
    //           item.status !== MedicalEmergencyStatus.RESOLVED && item.status.includes(rootStore.emsStore.getStatusFilterValue);
    //         }
    //       }
    //     ))
    //   } else if (rootStore.emsStore.getActiveTab == 2) {
    //     setFilterList(filteredMedicalEmergencies.filter(
    //       (item) => item.status === MedicalEmergencyStatus.RESOLVED
    //     ));
    //   }
    // },[rootStore.emsStore.getActiveTab, filteredMedicalEmergencies]);

    const onTabChange = (Tab: number = 0) => {
      if (Tab == 1) {
        setFilterList(
          filteredMedicalEmergencies.filter((item) => {
            return item.status !== MedicalEmergencyStatus.RESOLVED;
          })
        );
      } else if (Tab == 2) {
        setFilterList(
          filteredMedicalEmergencies.filter(
            (item) => item.status === MedicalEmergencyStatus.RESOLVED
          )
        );
      } else {
        setFilterList(
          filteredMedicalEmergencies.filter(
            (item) =>
              item.assignedEms === user?.username &&
              item.status !== MedicalEmergencyStatus.RESOLVED
          )
        );
      }
    };

    useEffect(() => {
      if (rootStore.emsStore.getRoleLabel.toLowerCase() !== "ems") {
        rootStore.emsStore.handleActiveTab(1);
      }
      rootStore.emsStore.handleActiveTab(rootStore.emsStore.getActiveTab);
      onTabChange(rootStore.emsStore.getActiveTab);
    }, [filteredMedicalEmergencies]);

    const onSearch = (tabIndex: number, searchString: string) => {
      setCurrentPage(1);
      if (!searchString) return; // Check if searchString is null, undefined, or empty
    
      const lowerSearchString = searchString.replaceAll(" ", "").toLocaleLowerCase();
    
      const filterByCommonFields = (item: any) => {
        const status = item?.status?.replaceAll(" ", "").toLocaleLowerCase() || "";
        const flightId = item?.flightId?.toLocaleLowerCase() || "";
        const symptoms = item?.symptoms?.replaceAll(",", "").replaceAll(" ", "").toLocaleLowerCase() || "";
        const passengerName = item?.passengerName?.toLocaleLowerCase() || "";
        const assignedEms = item?.assignedEms?.toLocaleLowerCase() || "";
    
        return (
          status.includes(lowerSearchString) ||
          flightId.includes(lowerSearchString) ||
          symptoms.includes(lowerSearchString) ||
          passengerName.includes(lowerSearchString) ||
          assignedEms.includes(lowerSearchString)
        );
      };
    
      let result;
      if (tabIndex === 1) {
        result = filteredMedicalEmergencies.filter(item => item.status !== MedicalEmergencyStatus.RESOLVED && filterByCommonFields(item));
      } else if (tabIndex === 2) {
        result = filteredMedicalEmergencies.filter(item => item.status === MedicalEmergencyStatus.RESOLVED && filterByCommonFields(item));
      } else {
        result = filteredMedicalEmergencies.filter(item => item.assignedEms === user?.username && item.status !== MedicalEmergencyStatus.RESOLVED && filterByCommonFields(item));
      }
    
      setFilterList(result);
    };
    

    const onSearchStrChange = (searchString: string) => {
      rootStore.emsStore.handleStatusFilter(searchString);
      if (searchString == "") {
        onTabChange(rootStore.emsStore.getActiveTab);
      }
    };

    const handleKeyDown = (e: any) => {
      if (rootStore.emsStore.getStatusFilterValue.length !== 0) {
        if (e.key === "Enter") {
          onSearch(
            rootStore.emsStore.getActiveTab,
            rootStore.emsStore.getStatusFilterValue
          );
        }
      }
    };
    const handlePageChange = (page: any) => {
      setCurrentPage(page);
    };

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const visibleUsersList = filterList.slice(startIndex, endIndex);

    return (
      <div className="active-incident-container">
        <Tabs
          activeIndex={rootStore.emsStore.getActiveTab}
          onActive={(index) => {
            rootStore.emsStore.handleActiveTab(index);
          }}
          margin={{ bottom: "20px" }}
          style={{
            justifyContent: "flex-start",
            flexDirection: "row",
            marginLeft: 20,
            marginBottom: 0,
          }}
        >
          {rootStore.emsStore.getRoleLabel.toLowerCase() === "ems" && (
            <Tab
              onClick={() => onTabChange(rootStore.emsStore.getActiveTab)}
              title={"Assigned to me"}
              className={
                rootStore.emsStore.getActiveTab == 0
                  ? "accordian-panel-header2"
                  : "accordian-panel-header1"
              }
              style={{ backgroundColor: "transparent", textAlign: "center" }}
            />
          )}
          <Tab
            onClick={() => onTabChange(rootStore.emsStore.getActiveTab)}
            title={"Active Incidents"}
            className={
              rootStore.emsStore.getActiveTab == 1
                ? "accordian-panel-header2"
                : "accordian-panel-header1"
            }
            style={{
              backgroundColor: "transparent",
              textAlign: "center",
              marginLeft:
                rootStore.emsStore.getRoleLabel.toLowerCase() === "ems"
                  ? 30
                  : 0,
            }}
          />
          <Tab
            onClick={() => onTabChange(rootStore.emsStore.getActiveTab)}
            title="Resolved Incidents"
            className={
              rootStore.emsStore.getActiveTab == 2
                ? "accordian-panel-header2"
                : "accordian-panel-header1"
            }
            style={{
              backgroundColor: "transparent",
              textAlign: "center",
              marginLeft: 30,
            }}
          />
        </Tabs>

        <AssignModal isShow={rootStore.emsStore.getAssignToMeModal} />
        <AssignToSomeoneModal
          emsName={rootStore.emsStore.selectedEmsId}
          isShow={rootStore.emsStore.getAssignToSomeoneModal}
          userType={rootStore.emsStore.getRoleLabel.toLowerCase()}
        />

        <Box className="content-box" style={{ height: "100%" }}>
          <Box
            className="search-button-container"
            style={{ minHeight: "unset" }}
          >
            <Box className="search-container">
              <CommonSearchInput
                onkeydown={(e: any) => handleKeyDown(e)}
                onchange={(e: any) => onSearchStrChange(e.target.value)}
              />
              <CommonButton
                title="Search"
                padding="12px 24px 12px 28px"
                color="#fff"
                bgColor="#357EFF"
                radius={10}
                border="1px solid #357EFF"
                lineheight="14px"
                ml={5}
                onclick={() =>
                  onSearch(
                    rootStore.emsStore.getActiveTab,
                    rootStore.emsStore.getStatusFilterValue
                  )
                }
                isDisableApply={false}
              />
            </Box>
            <Box className="assign-button" style={{ minHeight: "unset" }}>
              {rootStore.emsStore.getRoleLabel.toLowerCase() === "ems" &&
                rootStore.emsStore.getActiveTab !== 0 && (
                  <CommonButton
                    title="Assign to me"
                    padding="8px 12px"
                    color={showActionButton ? "#fff" : "#4B628AC7"}
                    bgColor={showActionButton ? "#357EFF" : "#E9F2FF"}
                    radius={8}
                    lineheight="20px"
                    disabled={showActionButton}
                    isDisableApply={true}
                    onclick={assignToMeClicked}
                    fontSize= "14px"
                  />
                )}
              {rootStore.emsStore.getRoleLabel.toLowerCase() != "admin" &&
                rootStore.emsStore.getActiveTab !== 0 && (
                  <CommonButton
                    title="Assign to someone"
                    padding="8px 12px"
                    color={showActionButton ? "#fff" : "#4B628AC7"}
                    bgColor={showActionButton ? "#357EFF" : "#E9F2FF"}
                    radius={8}
                    lineheight="20px"
                    ml={10}
                    disabled={showActionButton}
                    isDisableApply={true}
                    onclick={assignToSomeoneClicked}
                    fontSize= "14px"
                  />
                )}
              {rootStore.emsStore.getRoleLabel.toLowerCase() != "admin" &&
                rootStore.emsStore.getActiveTab == 0 && (
                  <CommonButton
                    title="Assign to someone"
                    padding="8px 12px"
                    color={showAssignButton ? "#fff" : "#4B628AC7"}
                    bgColor={showAssignButton ? "#357EFF" : "#E9F2FF"}
                    radius={8}
                    lineheight="20px"
                    ml={10}
                    disabled={showAssignButton}
                    isDisableApply={true}
                    onclick={assignToSomeoneClicked}
                    fontSize = '14px'
                  />
                )}
            </Box>
          </Box>
          <Box
            className="table-outer"
            style={{ height: "100%" }}
            height="100%"
            overflow="auto"
          >
            <DataTable
              columns={column2}
              data={visibleUsersList}
              resizeable
              onClickRow={({ datum }) => {
                onMedicalEmergencyClicked(datum);
              }}
              step={10}
              className="emergency-table"
            />

            {filterList.length == 0 && (
              <Box className="no-result-img">
                <img src={noResult} alt="no emergency found" />
                <p>No medical incidents assigned to you.</p>
              </Box>
            )}
          </Box>
          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              totalItems={totalItems}
              onPageChange={handlePageChange}
            />
          )}

          {rootStore.emsStore.getAssignedModal && (
            <Layer
              full="vertical"
              position="right"
              onClickOutside={() => {
                rootStore.emsStore.handleAssignModal(false);
                rootStore.emsStore.handleSelectEmsId("");
                rootStore.emsStore.handleEmsListSearch("");
              }}
              onEsc={() => {
                rootStore.emsStore.handleAssignModal(false);
                rootStore.emsStore.handleSelectEmsId("");
                rootStore.emsStore.handleEmsListSearch("");
              }}
              style={{
                borderRadius: "12px 0 0 12px",
                zIndex: 1000,
                width: 350,
              }}
            >
              <Box className="sidebar-title">
                <h4>Assign to someone</h4>
                <Button
                  onClick={() => {
                    rootStore.emsStore.handleAssignModal(false);
                    rootStore.emsStore.handleSelectEmsId("");
                    rootStore.emsStore.handleEmsListSearch("");
                  }}
                >
                  <img src={closeSidebar} style={{ width: 20, height: 20 }} />
                  Close
                </Button>
              </Box>
              <Box
                style={{
                  padding: "12px 14px 0 14px",
                  // marginBottom: 18,
                  position: "relative",
                }}
              >
                <CommonSearchInput
                  mWidth={"100%"}
                  onchange={(e: any) =>
                    rootStore.emsStore.handleEmsListSearch(e.target.value)
                  }
                />
                {rootStore.emsStore.getEmsListSearch.trim() != "" && (
                  <Box className="searchBox">
                    {filteredEmsList.map((ems) => {
                      if (
                        (ems.name + " " + ems.familyName)
                          .toLocaleLowerCase()
                          .replaceAll("", "")
                          .includes(
                            rootStore.emsStore.getEmsListSearch
                              .toLocaleLowerCase()
                              .replaceAll(" ", "")
                          )
                      ) {
                        return (
                          <Text
                            onClick={() => {
                              rootStore.emsStore.handleSelectEmsId(ems.id)
                              rootStore.emsStore.handleEmsListSearch("")
                            }
                            }
                            className={
                              rootStore.emsStore.getSelectedEmsId == ems.id
                                ? "searchListItem2"
                                : "searchListItem"
                            }
                          >
                            {ems.name + ems.familyName}
                          </Text>
                        );
                      } else {
                        return null;
                      }
                    })}
                  </Box>
                )}
              </Box>
              <Box style={{ padding: "0 20px 16px 20px", height: "87%" }}>
                <Box className="esmlist">
                  {filteredEmsList.map((ems) => {
                    return (
                      <Text
                        onClick={() =>
                          rootStore.emsStore.handleSelectEmsId(ems.id)
                        }
                        className={
                          rootStore.emsStore.getSelectedEmsId == ems.id
                            ? "listItem2"
                            : "listItem"
                        }
                      >
                        {ems.name + " " + ems.familyName}
                      </Text>
                    );
                  })}
                </Box>
                <CommonButton
                  title="Assign"
                  padding="8px 12px"
                  color={
                    rootStore.emsStore.getSelectedEmsId == ""
                      ? "#A7B6D1"
                      : "#fff"
                  }
                  bgColor={
                    rootStore.emsStore.getSelectedEmsId == ""
                      ? "#E9F2FF"
                      : "#357EFF"
                  }
                  radius={10}
                  border="1px solid #E9F2FF"
                  lineheight="20px"
                  disabled={
                    rootStore.emsStore.getSelectedEmsId == "" ? false : true
                  }
                  isDisableApply={true}
                  onclick={onAssignEmergencyClicked}
                  className="assignButton"
                  width="100%"
                />
              </Box>
            </Layer>
          )}
        </Box>
      </div>
    );
  }
);

export default MedicalEmergencyListScreen;
